"use client";
import styles from './styles.module.scss';
import Link from 'next/link';
import { useContext, useEffect, useState } from 'react';
import Image from 'next/image';
import { NavigationContext } from '@/providers/navigationProvider';
import { useTheme } from '@/providers/themeProvider';

const RightContent = ({ copyright, address, financeStatement }) => {
	const { theme } = useTheme();
	const context = useContext(NavigationContext);
	const { open, setOpen } = context || {};

	const [isMounted, setIsMounted] = useState(false);
	useEffect(() => {
		setIsMounted(true);
	}, []);

	const handleClick = (e) => {
		e.preventDefault();
		setOpen(!open);
	};

	// ✅ Avoid hydration mismatch by waiting for client mount
	const getImageSrc = (light, dark) =>
		theme === 'light' ? light : dark;

	const logoList = [
		{
			href: "https://www.clubautomation.com/",
			light: "/new_logos/new_ca_light_bg.png",
			dark: "/new_logos/new_ca_dark_bg.png",
			alt: "Club Automation Logo",
			className: "clubauto",
			width: 5523,
			height: 876,
		},
		{
			href: "https://zenplanner.com/",
			light: "/new_logos/new_zp_light_bg.png",
			dark: "/new_logos/new_zp_dark_bg.png",
			alt: "Zen Planner Logo",
			width: 4179,
			height: 876,
		},
		{
			href: "https://reclique.com/",
			light: "/new_logos/new_core_light_bg.png",
			dark: "/new_logos/new_core_dark_bg.png",
			alt: "Daxko Core Logo",
			className: "core",
			width: 2054,
			height: 876,
		},
		{
			href: "https://www.sugarwod.com/",
			light: "/new_logos/new_sw_light_bg.png",
			dark: "/new_logos/new_sw_dark_bg.png",
			alt: "SugarWOD Logo",
			width: 3979,
			height: 876,
		},
		{
			href: "https://www.clubautomation.com/engage-pro/",
			light: "/new_logos/new_ep_light_bg.png",
			dark: "/new_logos/new_ep_dark_bg.png",
			alt: "EngagePro Logo",
			width: 3979,
			height: 876,
		},
		{
			href: "https://www.motionsoft.net/",
			light: "/new_logos/new_ms_light_bg.png",
			dark: "/new_logos/new_ms_dark_bg.png",
			alt: "MotionSoft Logo",
			width: 3979,
			height: 876,
		},
	];

	return (
		<div className={`${styles.footer__col} ${styles.footer__colRight}`}>
			<nav className={styles.footer__nav}>
				<Link onClick={handleClick} href="#" target="_blank" className={styles.footer__navItem}>
					Menu
				</Link>
				<Link href="/demo" className={styles.footer__navItem}>
					Demo
				</Link>
				<Link href="/login" className={styles.footer__navItem}>
					Login
				</Link>
				<Link aria-label="Search" href="/search" className={styles.footer__navItem}>
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M14.76 13.27L20.49 19L19 20.49L13.27 14.76C12.2 15.53 10.91 16 9.5 16C5.91 16 3 13.09 3 9.5C3 5.91 5.91 3 9.5 3C13.09 3 16 5.91 16 9.5C16 10.91 15.53 12.2 14.76 13.27ZM9.5 5C7.01 5 5 7.01 5 9.5C5 11.99 7.01 14 9.5 14C11.99 14 14 11.99 14 9.5C14 7.01 11.99 5 9.5 5Z"
							fill="#E8236B"
						/>
					</svg>
				</Link>
			</nav>

			<nav className={styles.footer__nav}>
				<Link href="/company/careers" target="_blank" className={`${styles.footer__navItem} ${styles.footer__navItemSmall}`}>Careers</Link>
				<Link href="https://daxkoneworg.my.site.com/DaxkoCommunityHub/s/daxko-operations-community-homepage" target="_blank" className={`${styles.footer__navItem} ${styles.footer__navItemSmall}`}>Help Center</Link>
				<Link href="/company/privacy-policy/" className={`${styles.footer__navItem} ${styles.footer__navItemSmall}`}>Privacy Policy</Link>
				<Link href="/vulnerability-disclosure" className={`${styles.footer__navItem} ${styles.footer__navItemSmall}`}>Vulnerability Disclosure</Link>
				<Link href="/terms" className={`${styles.footer__navItem} ${styles.footer__navItemSmall}`}>Terms</Link>
				<Link href="/service-agreement" className={`${styles.footer__navItem} ${styles.footer__navItemSmall}`}>Master Service Agreement</Link>
				<Link href="/considering-amilia" className={`${styles.footer__navItem} ${styles.footer__navItemSmall}`}>Daxko vs Alternatives</Link>
			</nav>

			{/* ✅ Defer theme-dependent rendering to avoid hydration mismatch */}
			{isMounted && (
				<nav className={styles.footer__products}>
					{logoList.map(({ href, light, dark, alt, className, width, height }, i) => (
						<Link key={i} className={`${styles.footer__productsItem} ${className || ''}`} href={href} target="_blank">
							<Image
								src={`${getImageSrc(light, dark)}`}
								width={width}
								height={height}
								alt={alt}
								priority
							/>
						</Link>
					))}
				</nav>
			)}

			<div className={styles.footer__copyright}>{address}</div>
			<div className={styles.footer__copyright}>{financeStatement}</div>
			<div className={styles.footer__copyright}>
				Daxko LLC, is a registered Independent Sales Organization of Fiserv, Milwaukee, WI.
			</div>
			<div className={styles.footer__copyright}>{copyright}</div>
		</div>
	);
};

export default RightContent;
